const STEP_VALUE  = 0.001;

cc.Class({
    ctor () {
        this.gui = this._createDatGUIInstance();
        this.soundMix = {};
        this.controllers = [];
    },

    _createDatGUIInstance () {
        const gui = new dat.GUI({
            name: 'Volume Mixer',
            height: 200,
            load: JSON,
            closed: true,
            preset: 'Default',
            closeOnTop: true
        });

        gui.useLocalStorage = true;
        gui.width = 350;

        gui.add(this,'_downloadSettings').name('Export Volume Settings');

        return gui;
    },

    init (audiomanager) {
        this.audio = audiomanager;
        this.audio.registerEvent('sound-loaded', this.handleNewSound, this);

        this.updateUI();
    },

    handleNewSound (audioClip) {
        cc.log(`audio file load ${  audioClip.name}`);

        this.updateUI();
    },

    loadSoundSettingsJson (json) {
        try {
            this.loadSoundSettings = JSON.parse(json);
        } catch (err) {
            cc.error(err);
        }
    },

    updateUI () {
        const sounds =  this.audio.loadedSoundSettings;

        for (const audio in sounds) {
            if (typeof audio === 'string') {
                this.soundMix[audio] =  typeof this.audio.loadedSoundSettings[audio] !== 'undefined' ?
                    this.audio.loadedSoundSettings[audio].volume  : 1.0;

                const controller = this.controllers.find((controller) => controller.property === audio);

                if (typeof controller === 'undefined') {
                    const controller = this.gui.add(this.soundMix, audio, 0.0, 1.0, STEP_VALUE);

                    controller.onChange((value) => {
                        this.audio.loadedSoundSettings[audio].volume = value;
                        if (this.audio.loadedSoundSettings[audio].isSprite) {
                            this.audio.setSoundVolume(audio.substr(7), value);
                        } else {
                            this.audio.setSoundVolume(this.audio.loadedSoundSettings[audio].clip, value);
                        }

                    });

                    this.controllers.push(controller);
                } else {
                    controller.updateDisplay();
                }

            }

        }

        this.gui.remember(this.soundMix);
    },

    _downloadSettings () {
        const getFileName = () => {
            return `${require('PSConfig').get().gameName}-sound.json`;
        };

        cc.log(this.audio.loadedSoundSettings);

        const obj = {};

        // export only volume
        for (const audio in this.audio.loadedSoundSettings) {
            if (audio) {
                obj[audio] = {};
                obj[audio].volume = this.audio.loadedSoundSettings[audio].volume;
            }

        }

        // uses file-saver
        // eslint-disable-next-line no-undef
        saveAs(new Blob([JSON.stringify(obj, null, '\t')]), getFileName());

    }

});

